export { DialogComponent } from './dialog/dialog.component';
export { DialogTitleBarComponent } from './dialog/dialog-titlebar.component';
export { DialogActionsComponent } from './dialog/dialog-actions.component';
export { DialogService } from './dialog/dialog.service';
export { DialogCloseResult, DialogRef, DialogSettings, DialogAction } from './dialog/dialog-settings';
export { WindowComponent } from './window/window.component';
export { WindowTitleBarComponent } from './window/window-titlebar.component';
export { WindowMaximizeActionDirective } from './window/actions/window-maximize-action.directive';
export { WindowMinimizeActionDirective } from './window/actions/window-minimize-action.directive';
export { WindowCloseActionDirective } from './window/actions/window-close-action.directive';
export { WindowRestoreActionDirective } from './window/actions/window-restore-action.directive';
export { WindowSettings, WindowRef, WindowCloseResult } from './window/window-settings';
export { WindowService } from './window/window.service';
export { DialogModule } from './dialog.module';
export { WindowModule } from './window.module';
export { DialogsModule } from './dialogs.module';



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dialog/dist/es/main.js
// module id = ../../../../@progress/kendo-angular-dialog/dist/es/main.js
// module chunks = vendor